import React, { useEffect } from "react";
import { Modal, Form, Input, Select } from "antd";
import "./style.css";

const { Option } = Select;

const AddUserModal = ({ isModalOpen, onCancel, onAddUser, loading, initialValues }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        } else {
            form.resetFields();
        }
    }, [initialValues, form, isModalOpen]);

    return (
        <Modal
            title={initialValues ? "Edit user" : "Add user"}
            open={isModalOpen}
            onCancel={onCancel}
            onOk={() => form.submit()}
            okText={initialValues ? "Update" : "Add"}
            cancelText="Cancel"
            confirmLoading={loading}
            className="custom-modal"
            centered
            width={440}
            maskStyle={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)" }}
        >
            <Form form={form} layout="vertical" className="text-white" onFinish={onAddUser}>
                <Form.Item name="firstName" label="First name" rules={[{ required: true }]}>
                    <Input autoComplete="off" placeholder="Jane" />
                </Form.Item>
                <Form.Item name="lastName" label="Last name" rules={[{ required: true }]}>
                    <Input autoComplete="off" placeholder="Doe" />
                </Form.Item>
                <Form.Item name="telegramId" label="Telegram ID" rules={[{ required: true }]}>
                    <Input autoComplete="off" placeholder="@username or numeric id" />
                </Form.Item>
                <Form.Item name="role" label="Role" rules={[{ required: true }]}>
                    <Select placeholder="Select role" popupClassName="glass-ant-select-dropdown">
                        <Option value="admin">Admin</Option>
                        <Option value="support">Support</Option>
                        <Option value="client">Client</Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddUserModal;
